import { Card, Collapse } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { ReactComponent as CollapseSVG } from "go-core/images/svg/actions/collapse.svg";
import { VenueSettingsApi } from "../../../../../../../../../../../services/Api/Organization/types";
import { VenueSettingsItemApi } from "../../../../../../../../../../../services/Api/types";
import useCollapseCard from "../hooks/useCollapseCard";
import SettingsTable from "./SettingsTable";

interface Props {
	types: VenueSettingsItemApi[];
	form: UseFormReturn<VenueSettingsApi>;
	title: string;
	search: string;
}

const OtherSalesSettingsCard = (props: Props): JSX.Element => {
	const { toggleCollapse, collapseIn, getCollapseIconStyles } = useCollapseCard(props.search, props.types);

	return (
		<Card className={"venue-settings"}>
			<Card.Body>
				<div className={"title"} onClick={() => toggleCollapse()}>
					<h5>{props.title}</h5>
					<CollapseSVG style={getCollapseIconStyles()} className={"collapse-icon"} />
				</div>
				<Collapse in={collapseIn}>
					<div>
						<table className={"table table-preview"}>
							<SettingsTable types={props.types} form={props.form} />
						</table>
					</div>
				</Collapse>
			</Card.Body>
		</Card>
	);
};
export default OtherSalesSettingsCard;
